import {
  SwitchProps as MantineSwitchProps,
  Switch as MantineSwitch,
} from '@mantine/core';

export type SwitchProps = MantineSwitchProps;

export const Switch = MantineSwitch;

Switch.displayName = 'Switch';
